var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',{staticClass:"box-shadow-card w-100 h-100"},[_c('div',{staticClass:"d-flex "},[_c('h2',[_vm._v("Payment Status is loading...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }